import React from 'react';
import EducationTimeline from './EducationTimeline';
import ExperienceTimeline from './ExperienceTimeline';
import './styles/QualificationsSection.scss';

const QualificationsSection = () => {
  return (
    <section id="qualifications" className="qualifications-section">
      <h2 className="qualifications-section-title">My Journey</h2>
      <div className="qualifications-content-wrapper">
        <EducationTimeline />
        <ExperienceTimeline />
      </div>
    </section>
  );
};

export default QualificationsSection;